import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "form",
    "statusSelect",
    "startDateField",
    "projectedEndDateField",
    "endDateField",
    "startDate",
    "projectedEndDate",
    "endDate",
    "submitButton",
  ];

  declare readonly formTarget: HTMLFormElement;
  declare readonly statusSelectTarget: HTMLSelectElement;
  declare readonly startDateFieldTarget: HTMLDivElement;
  declare readonly projectedEndDateFieldTarget: HTMLDivElement;
  declare readonly endDateFieldTarget: HTMLDivElement;
  declare readonly startDateTarget: HTMLInputElement;
  declare readonly projectedEndDateTarget: HTMLInputElement;
  declare readonly endDateTarget: HTMLInputElement;
  declare readonly submitButtonTarget: HTMLButtonElement;

  declare readonly hasStartDateFieldTarget: boolean;
  declare readonly hasProjectedEndDateFieldTarget: boolean;
  declare readonly hasEndDateFieldTarget: boolean;
  declare readonly hasStartDateTarget: boolean;
  declare readonly hasProjectedEndDateTarget: boolean;
  declare readonly hasEndDateTarget: boolean;

  connect() {
    this.statusChanged();
  }

  statusChanged() {
    const status = this.statusSelectTarget.value;

    // Hide all date fields by default
    this.hideAllDateFields();

    // Remove required attributes
    this.removeRequiredAttributes();

    switch (status) {
      case "applying":
        // Show neither start nor end date
        break;
      case "pending":
        // Show start and projected_end_date (not required)
        this.showField(this.startDateFieldTarget);
        this.showField(this.projectedEndDateFieldTarget);
        this.defaultToToday(this.hasStartDateTarget ? this.startDateTarget : undefined);
        break;
      case "placed":
        // Require start and projected_end_date
        this.showField(this.startDateFieldTarget);
        this.showField(this.projectedEndDateFieldTarget);
        this.defaultToToday(this.hasStartDateTarget ? this.startDateTarget : undefined);
        if (this.hasStartDateTarget) {
          this.startDateTarget.required = true;
        }
        if (this.hasProjectedEndDateTarget) {
          this.projectedEndDateTarget.required = true;
        }
        break;
      case "completed":
        // Show end date
        this.showField(this.endDateFieldTarget);
        this.defaultToToday(this.hasEndDateTarget ? this.endDateTarget : undefined);
        if (this.hasEndDateTarget) {
          this.endDateTarget.required = true;
        }
        break;
      case "abandoned":
        // Show end date
        this.showField(this.endDateFieldTarget);
        this.defaultToToday(this.hasEndDateTarget ? this.endDateTarget : undefined);
        break;
      case "ejected":
        // Show end date
        this.showField(this.endDateFieldTarget);
        this.defaultToToday(this.hasEndDateTarget ? this.endDateTarget : undefined);
        break;
    }
  }

  private hideAllDateFields() {
    if (this.hasStartDateFieldTarget) {
      this.hideField(this.startDateFieldTarget);
    }
    if (this.hasProjectedEndDateFieldTarget) {
      this.hideField(this.projectedEndDateFieldTarget);
    }
    if (this.hasEndDateFieldTarget) {
      this.hideField(this.endDateFieldTarget);
    }
  }

  private removeRequiredAttributes() {
    if (this.hasStartDateTarget) {
      this.startDateTarget.required = false;
    }
    if (this.hasProjectedEndDateTarget) {
      this.projectedEndDateTarget.required = false;
    }
    if (this.hasEndDateTarget) {
      this.endDateTarget.required = false;
    }
  }

  private showField(field: HTMLElement | undefined) {
    if (field) {
      field.style.display = "block";
    }
  }

  private defaultToToday(input: HTMLInputElement | undefined) {
    if (input && !input.value) {
      input.value = new Date().toISOString().split("T")[0];
    }
  }

  private hideField(field: HTMLElement | undefined) {
    if (field) {
      field.style.display = "none";
    }
  }
}
